import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import { StripeProvider } from 'react-stripe-elements';
import nextI18nextConfig from '~/../next-i18next.config';
import securePage, { securePageServerSideContext } from '~/../hocs/securePage';
import Layout from '~/containers/Layout';
import PremiumContainer from '~/containers/PremiumPage';
import Config, { keyConfig } from '~/config';
import {
  loadPricePremium,
  loadSinglePricePremium,
} from '~/containers/PaymentModal/actions';
import ChinaWrap from '~/components/ChinaWrap';
import { fileHelper } from '~/utils';
import { wrapper } from '~/store';
import { getDisplayName } from '~/utils/file-helper';

const roles = Config.getRoles();

@securePage(
  [roles.GUEST, roles.FREE_MEMBER],
  ['common', 'component-FreeAndPremiumCompareTable'],
)
class PremiumPage extends React.Component {
  state = {
    stripe: null,
  };

  async componentDidMount() {
    if (process.browser) {
      this.setState({
        stripe: await fileHelper.loadStripeJS(),
      });
    }
  }

  render() {
    const { t } = this.props;

    if (process.browser && !this.state.stripe) return null;

    return (
      <Layout path={'/premium'}>
        <Head>
          <title>
            {t('title_premium_page_seo')} - {Config.renderTitleOpenSearch()}
          </title>
          <meta
            id="meta-keywords"
            name="keywords"
            content={t(
              Config.getPrefixContent('meta_keywords_premium_page_seo'),
            )}
          />
          <meta
            id="meta-description"
            name="description"
            content={t(
              Config.getPrefixContent('meta_description_premium_page_seo'),
            )}
          />
        </Head>
        <StripeProvider stripe={this.state.stripe}>
          <PremiumContainer />
        </StripeProvider>
      </Layout>
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common', 'component-FreeAndPremiumCompareTable'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      sessionId,
      ssoToken,
      req,
      query,
    } = await securePageServerSideContext({
      ...ctx,
      store,
      pageName: getDisplayName(PremiumPage),
      roles: [roles.GUEST, roles.FREE_MEMBER],
    });

    if (!Config.isChina()) {
      store.dispatch(loadPricePremium(req));
    } else {
      store.dispatch(loadSinglePricePremium(req));
    }

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default PremiumPage;
